<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app >
      <v-toolbar-title style="font-size:1rem;width:94%;padding-left:1.2rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">
          报障工单
          <!-- <span v-if="companyInfo.COMPANY_NAME"> - {{companyInfo.COMPANY_NAME}}</span> -->
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon @click="showDateSelected">
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="padding:0;">
          <v-list-item @click="goCurOrderList" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <i class="fa fa-file-text-o" />
              <span>团队报障单</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content style="background: #eee;">
      <v-container style="padding-bottom:4rem;background: #eee">
        <!-- <div>
          <div style="font-size:1rem;font-weight:bold;padding:0.5rem 0;padding-left:0.2rem;color: rgba(33,33,33,0.9);">我的团队</div>
          <CompanyOrderList v-if="!loading" />
        </div> -->
        <div>
          <!-- <div style="font-size:1rem;font-weight:bold;padding:0.5rem 0;padding-left:0.2rem;color: rgba(33,33,33,0.9);">我参与的</div> -->
          <!-- <div style="height:30px;">
            <span class="us_block_more_text" @click="goOrderStat">
              <i class="fa fa-bar-chart" aria-hidden="true"></i>
              <span> 统计</span><i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </div> -->
          <PlayerOrderList ref="PlayerOrderList" v-if="!loading" />
        </div>
        <div class="us-create-btn" @click="goCreateOrder">
          <v-btn dark fab right color="#5cbbf6"><v-icon>mdi-plus</v-icon></v-btn>
        </div>
        <TDateSelector :visible.sync="dateScdVis" :value.sync="datev"  />
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import PlayerOrderList from './components/PlayerOrderList'
// import CompanyOrderList from './components/CompanyOrderList'
import TDateSelector from '../../components/TDateSelector'
export default {
  components: {
    PlayerOrderList,
    // CompanyOrderList,
    TDateSelector
  },
  data() {
    return {
      loading: true,
      companyInfo: {},
      dateScdVis: false,
      datev: new Date().toISOString().substr(0, 10)
    }
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    initData() {
      var that = this
      that.$store.commit('SET_FNAVVAL', 2)
      // that.loading = true
      that.companyInfo = that.$AppHelper.getCustomData('company_info');
      that.loading = false
      that.$nextTick(function() {
        that.$refs.PlayerOrderList.initData()
      })
    },
    goCreateOrder() {
      this.$router.goPage('/CreateOrder')
    },
    showDateSelected() {
      this.dateScdVis = !this.dateScdVis
    },
    goOrderStat() {
      this.$router.goPage('/OrderStat')
    },
    goCurOrderList() {
      this.$router.goPage('/CurOrderList')
    }
  },
  mounted() {
  },
  activated() {
    var that = this
    that.initData()
  },
  deactivated() {
  }
}
</script>

<style scoped>

.us-v-app{
  background-color: #f6f6f6 !important;
}

.us-create-btn{
  position:fixed;
  bottom: 4.5rem;
  right: 1.5rem;
}

.us_block_more_text{
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-right:0.4rem;
  float:right;
  color:#9e9e9e;
}
.us_block_more_text span{
  font-size:0.8rem;
}
.us_block_more_text i{
  margin-left:0.4rem;
}

</style>
